import React from 'react'

export default function Footer() {
  return (
    <footer>
      <p className="copyright">COPYRIGHT ©paddle inc. ALL RIGHTS RESERVED</p>
    </footer>
  )
}